;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Lockup from 'components/blocks/shared/Lockup';
import Button from 'components/ui/Button';
import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import SvgIcon from 'components/ui/SvgIcon';

import styles from './Overlay.module.scss';

const Overlay = ({
    eyebrow,
    headline,
    bodyCopy,
    image,
    image2 = null,
    cta,
    theme,
    setIsOpen = () => {},
    isOpen = false,
    isActive = false,
}) => {
    return (
        <div
            className={cx(styles.root, {
                [styles.isOpen]: isActive && isOpen,
                [styles.isClosing]: !isActive || !isOpen,
                [styles[`theme-${theme}`]]: theme,
            })}
        >
            <div className={styles.inner}>
                <div className={styles.contentWrapper}>
                    <div>
                        <Lockup
                            eyebrow={{ text: eyebrow }}
                            headline={{ text: headline }}
                            copy={{ text: bodyCopy }}
                            theme="Medium"
                        />
                    </div>
                    {image && (
                        <div
                            className={cx(styles.imageWrapper, {
                                [styles['image-square']]: image2,
                            })}
                        >
                            <Img
                                className={styles.image}
                                src={image?.url}
                                width={image?.width}
                                height={image?.height}
                                fallbackImageWidth={768 * 1.5}
                                alt=""
                                customSources={[
                                    {
                                        src: image?.url,
                                        imageWidth: 768 * 1.5,
                                    },
                                ]}
                            />
                            {image2 && (
                                <Img
                                    className={styles.image}
                                    src={image2?.url}
                                    width={image2?.width}
                                    height={image2?.height}
                                    fallbackImageWidth={768 * 1.5}
                                    alt=""
                                    customSources={[
                                        {
                                            src: image2?.url,
                                            imageWidth: 768 * 1.5,
                                        },
                                    ]}
                                />
                            )}
                        </div>
                    )}
                    {cta && <ButtonCTA className={styles.cta} {...cta} />}
                </div>
            </div>
            <Button
                onClick={() => setIsOpen(false)}
                className={styles.closeButton}
            >
                <span className="sr-only">Close</span>
                <SvgIcon className={styles.closeIcon} type="close" />
            </Button>
        </div>
    );
};

Overlay.propTypes = {
    image: PropTypes.object,
    image2: PropTypes.object,
    eyebrow: PropTypes.string,
    headline: PropTypes.string,
    bodyCopy: PropTypes.object,
    copy: PropTypes.string,
    cta: PropTypes.object,
    theme: PropTypes.string,
    isOpen: PropTypes.bool,
    isActive: PropTypes.bool,
    setIsOpen: PropTypes.func,
};

export default Overlay;
